import avatarModule from '../avatarModule';

function loadingAnimated() {
  return {
    restrict: 'A',
    replace: false,
    templateUrl: 'loading-animated'
  };
}

avatarModule.directive('loadingAnimated', loadingAnimated);

export default loadingAnimated;
